export function toTitleCase(s: string): string {
  return s
    .replace(/[-_]+/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

function pad2(n: number): string {
  return n.toString().padStart(2, "0");
}

export function currentMonthIso(now: Date = new Date()): string {
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}`;
}

export function isValidMonthIso(value: string | null | undefined): boolean {
  return typeof value === "string" && /^\d{4}-\d{2}$/.test(value);
}
